import React, { useState, useContext, useEffect } from "react";
import Col from "react-bootstrap/Col";
import AuthContext from "../../Context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

function DeleteUser() {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(true);

  let { uid } = useParams();

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/${uid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setUser(response.data.user);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const handleSubmit = async () => {
    try {
      await axios({
        method: "delete",
        url: `${process.env.REACT_APP_BACKEND_URL}/users/${uid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate(`/residence-details/${user.residence}`);
    } catch (error) {
      console.log(error);
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="delete-user">
        <Col>
          <h4>Eliminar usuario</h4>
        </Col>
        <Col className="delete-user-form">
          <Col className="mb-3">
            <p>{`Estas por eliminar al usuario ${user.firstName} ${user.lastName}. Una vez eliminado no podrás recuperar su información. ¿Estás seguro?`}</p>
          </Col>
          <Col>
            <Button variant="info" onClick={handleSubmit}>
              Eliminar
            </Button>
            <Button
              variant="danger"
              onClick={() => navigate(`/residence-details/${user.residence}`)}
            >
              Cancelar
            </Button>
          </Col>
        </Col>
      </Col>
    );
  }
}

export default DeleteUser;
